// extracted by mini-css-extract-plugin
export default {"brandPromo":"IF-z","carousel":"JF-z"};